import React, { useEffect, useState, useRef } from "react";
import DataTable from 'react-data-table-component';
import dashboardJSON from '../json-data/dgdashboard.json';
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { OverlayTrigger, Popover, Button, Modal, Col, Form, Row, Tooltip } from 'react-bootstrap';
import { configData } from '../config/systemconfigurationconstants';
import * as AWS from 'aws-sdk';
import { findWindows } from 'windows-iana';
import { useEncryption } from '../customHooks/useEncryption';
import { ToastContainer, toast } from "react-toastify";

const ExpandedRowComponent = ({ orderDetails }) => {
  const [columns, setColumns] = useState([]);
  const [fileDetails, setFileDetails] = useState([]);
  // const fileDetailsRef = useRef([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dotloader, setDotLoader] = useState(true);
  const { encrypt, decrypt } = useEncryption();
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  };
  // AWS Key Details
  const lambda = new AWS.Lambda({
    region: configData.LAMBDA_REGION,
    accessKeyId: decrypt(getCookie('ak')),
    secretAccessKey: decrypt(getCookie('sk'))
  });

  useEffect(() => {
    const isRowExpanded = localStorage.getItem('isrowexpanded');

    if (isRowExpanded === "true") {
      const fetchFileDetails = async () => {
        setDotLoader(false)
        const ianaTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const windowsTZ = findWindows(ianaTimeZone);

        setDotLoader(false);
        setError(null);

        const inputJSON = {
          Command: configData.GET_FILE_DETAILS_BY_LOAN_GUID,
          SecurityId: null,
          SecurityToken: localStorage.getItem('SecurityToken'),
          EventContextId: null,
          CallerSourceId: null,
          CallerSourceName: null,
          LoanGuid: orderDetails?.LG,
          TimeZone: windowsTZ[0]
        };

        const params = {
          FunctionName: configData.LAMBDA_FUNCTION_NAME1,
          Payload: JSON.stringify(inputJSON)
        };

        try {
          const data = await lambda.invoke(params).promise();
          const lambdaResponse = JSON.parse(data.Payload.toString());
          const parsedBody = JSON.parse(lambdaResponse.body);

          // fileDetailsRef.current = parsedBody.FileDtls || []; // Save to ref
          setFileDetails(parsedBody.FileDtls || []);
          localStorage.setItem("childgriddata", JSON.stringify(parsedBody.FileDtls || []))
          localStorage.setItem("childgridheader", JSON.stringify(parsedBody.FlHdr))
          const newColumns = parsedBody.FlHdr.map(header => ({
            name: header.DN,
            selector: row => row[header.FN],
            sortable: true,
            width: header.Css,
            cell: row => (
              <OverlayTrigger
                placement="top"
                overlay={customTooltip(row[header.FN])}
              >
                <span className="text-truncate">{row[header.FN]}</span>
              </OverlayTrigger>
            )
          }));

          setColumns(newColumns);
        } catch (err) {
          console.error(err);
          setError('Failed to fetch file details');
        } finally {
          setTimeout(() => {
            setDotLoader(true);
          }, 1000);
        }
      };

      if (orderDetails?.LG) {
        fetchFileDetails();
      }
    } else {
      let gettablevaluefromLs = JSON.parse(localStorage.getItem('childgriddata'))
      let gettableheaderfromLs = JSON.parse(localStorage.getItem('childgridheader'))
      setFileDetails(gettablevaluefromLs); // Restore from ref
      const newColumns = gettableheaderfromLs.map(header => ({
        name: header.DN,
        selector: row => row[header.FN],
        sortable: true,
        width: header.Css,
        cell: row => (
          <OverlayTrigger
            placement="top"
            overlay={customTooltip(row[header.FN])}
          >
            <span className="text-truncate">{row[header.FN]}</span>
          </OverlayTrigger>
        )
      }));

      setColumns(newColumns);
      // setTimeout(() => {
      setDotLoader(true);
      // }, 1000);
    }
  }, [orderDetails]);

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  if (error) {
    return <div>{error}</div>;
  }
  const customTooltip = (text) => (
    <Tooltip id="tooltip">{text}</Tooltip>
  );
  const navigateToIGURL = (fileDtls) => {
    if (fileDtls.IG1ClkURL !== null && fileDtls.IG1ClkURL !== "") {
      window.open(fileDtls.IG1ClkURL, '_blank');
    } else {
      toast.error("No IG URL Available For This Files", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

  }
  return (
    <>{dotloader ?
      <div className="row m-0">
        <div className="col-sm-12 order-detailgrid p-3">
          {fileDetails.length > 0 && (
            <DataTable
              columns={columns}
              data={fileDetails}
              pagination
              dense
              pointerOnHover
              onRowClicked={(row) => navigateToIGURL(row)}
            />
          )}
        </div>
      </div> : <div style={{ marginTop: "2%", marginBottom: "2%" }} className="d-flex justify-content-center">
        <div className="loader"></div>
      </div>}
    </>
  );
};

export default ExpandedRowComponent;